export const SEED_PROJECTS = [
    {
        key: 'ssn-main',
        name: 'SSN Main Server',
        description: 'The primary Spring Side Network FiveM server.',
        colour: '#4f7cff',
    },
    {
        key: 'ssn-platform',
        name: 'SSN Platform',
        description: 'Websites, panels and internal tooling.',
        colour: '#8b5cf6',
    },
    {
        key: 'ssn-infrastructure',
        name: 'SSN Infrastructure',
        description: 'Hosting, deployment and operational infrastructure.',
        colour: '#0ea5e9',
    },
];
export const SEED_CATEGORIES = [
    { key: 'fivem', name: 'FiveM', description: 'In-game resources and scripting.', colour: '#f59e0b' },
    { key: 'backend', name: 'Backend', description: 'Server-side services and APIs.', colour: '#10b981' },
    { key: 'frontend', name: 'Frontend', description: 'User interfaces and client applications.', colour: '#6366f1' },
    { key: 'infrastructure', name: 'Infrastructure', description: 'Hosting, CI/CD and operations.', colour: '#0ea5e9' },
    { key: 'bug-fix', name: 'Bug Fix', description: 'Correcting defective behaviour.', colour: '#ef4444' },
    { key: 'feature', name: 'Feature', description: 'New functionality.', colour: '#8b5cf6' },
    { key: 'maintenance', name: 'Maintenance', description: 'Upkeep, refactoring and chores.', colour: '#64748b' },
];
/** Estimated complexity captured at task creation (§4). */
export const TASK_COMPLEXITIES = ['TRIVIAL', 'SMALL', 'MEDIUM', 'LARGE', 'EPIC'];
export const TASK_COMPLEXITY_META = {
    TRIVIAL: { key: 'TRIVIAL', label: 'Trivial', description: 'Under an hour.', indicativeHours: 0.5, order: 10 },
    SMALL: { key: 'SMALL', label: 'Small', description: 'A few hours.', indicativeHours: 3, order: 20 },
    MEDIUM: { key: 'MEDIUM', label: 'Medium', description: 'About a day.', indicativeHours: 8, order: 30 },
    LARGE: { key: 'LARGE', label: 'Large', description: 'Several days.', indicativeHours: 24, order: 40 },
    EPIC: { key: 'EPIC', label: 'Epic', description: 'A week or more — consider splitting it.', indicativeHours: 60, order: 50 },
};
export function isTaskComplexity(value) {
    return typeof value === 'string' && TASK_COMPLEXITIES.includes(value);
}
//# sourceMappingURL=reference.js.map